import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle, ExternalLink } from "lucide-react";

export default function Faq({ faq = [], categories = [] }) {
  const cats = categories.length ? categories : Array.from(new Set(faq.map((f) => f.category).filter(Boolean)));
  const [active, setActive] = useState(cats[0] || null);
  const items = active ? faq.filter((f) => f.category === active) : faq;

  return (
    <section id="faq" className="scroll-mt-24 py-20 lg:py-28 bg-[#F3EFE6]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#E2EBE1] mb-5">
            <HelpCircle className="w-7 h-7 text-[#2D5A27]" />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#1C2D24]">
            Häufig gestellte Fragen
          </h2>
          <p className="mt-4 text-lg text-[#4A5D52]">Die meistgestellten Fragen rund um Ernährung, Knochen, Darm &amp; Milch – gemeinsam mit unserer Partnerseite LacLive.</p>
        </div>

        {cats.length > 0 && (
          <div className="flex flex-wrap justify-center gap-2 mb-8" data-testid="faq-category-filter">
            {cats.map((c) => (
              <button
                key={c}
                data-testid={`faq-category-${c}`}
                onClick={() => setActive(c)}
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
                  active === c ? "bg-[#1E3F20] text-white" : "bg-white text-[#4A5D52] ring-1 ring-[#E2DDD3] hover:bg-[#EBE7DF]"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        )}

        <Accordion type="single" collapsible className="space-y-3">
          {items.map((item, i) => (
            <AccordionItem
              key={`${active}-${i}`}
              value={`faq-${active}-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white rounded-2xl ring-1 ring-[#E2DDD3] px-5 border-b-0"
            >
              <AccordionTrigger className="text-left font-semibold text-[#1C2D24] hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#4A5D52] leading-relaxed pb-5">
                {item.a}
                {item.link && (
                  <a
                    href={item.link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`faq-link-${i}`}
                    className="mt-3 inline-flex items-center gap-1.5 text-[#C87D55] font-semibold hover:underline"
                  >
                    {item.link.label} <ExternalLink className="w-3.5 h-3.5" />
                  </a>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
